import React from "react";
import ComponentCard from "../../components/common/ComponentCard";
import SliderListComponent from "../../components/slider/SliderListComponent";
import PageMeta from "../../components/common/PageMeta";

const SliderList = () => {

    return (
        <>
            <PageMeta title="Danh sách slider" description="Danh sách slider"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <SliderListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default SliderList;
